import React from 'react';
import Entry from '../entry';
import { Flex, Text } from 'rebass';
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"

export default () => {
  const title = 'Zeek JSON Analysis';
  const hints = [(<Flex flexDirection='row' flexWrap='wrap'><Text mr={2}>[Wunrose Openslae] </Text><a rel="noopener noreferrer" target="_blank" href="https://pen-testing.sans.org/blog/2019/12/03/parsing-zeek-json-logs-with-jq-2">Parsing Zeek JSON Logs with JQ</a></Flex>),
];
  const data = useStaticQuery(graphql`
    query {
      zeekStart: file(relativePath: { eq: "zeekStart.png" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      zeekSuccess: file(relativePath: { eq: "zeekSuccess.png" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      cranZeek: file(relativePath: { eq: "cranZeek.png" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid
          }
        }
      }

    }
  `);
  const extra = (
    <>
    <Img fluid={data.cranZeek.childImageSharp.fluid}
            style={{ margin: 0,  maxHeight: '35vh', width: '72vw' }}
            imgStyle={{ objectFit: 'contain' }}
    />
    <Text mb={1} fontSize='13px' alignSelf='center'>Location: inside the Sleigh Shop</Text>
    </>
  );

  return (
    <Entry
      title={title}
      hints={hints}
      extra={extra}
    >
      <Text my={2}>We will use JQ to sort the entries in <code>conn.log</code> by duration.</Text>
      <Img fluid={data.zeekStart.childImageSharp.fluid}
              style={{ margin: 0,  maxHeight: '80vh', width: '70vw' }}
              imgStyle={{ objectFit: 'contain' }}
      />
      <Text my={2}>The "response host" that we found is indeed the answer: </Text>
      <Img fluid={data.zeekSuccess.childImageSharp.fluid}
              style={{ margin: 0,  maxHeight: '70vh', width: '70vw' }}
              imgStyle={{ objectFit: 'contain' }}
      />
    </Entry>
  )

};
